export default {
  sortHelper: {
    zIndex: '1000',
    borderRadius: '4px',
    borderBottom: '1px solid #ddd',
    background: '#fff'
  },
  criteriaContainer: {
    padding: '1px 0 0',
    minHeight: '250px',
    maxHeight: '250px',
    overflow: 'auto'
  },
  criteriaWrapper: {
    margin: '10px 0 0',
    position: 'relative',
    '&:after': {
      pointerEvents: 'none',
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '100%',
      height: '20px',
      background:
        'linear-gradient(to top, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%)'
    }
  },
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16px'
  },
  addLineButton: {
    padding: '0 2px'
  }
}
